var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2F3641",
    fillRule: "evenodd",
    points: "15.707 16 14 17.707 8.293 12 14 6.293 15.707 8 11.707 12"
  })));
};
export default SvgChevronLeft;